





































































import { Component, Vue, Watch } from 'vue-property-decorator';
type ZoneKey = keyof RentCalculator['plafond'];

@Component
export default class RentCalculator extends Vue {
  calculator = false;
  result = 0;
  calcul = {
    geozone: 'A' as ZoneKey,
    surface: 0,
    surface_terrace: 0,
    isRdc: false
  };

  plafond = {
    Abis: 19.51,
    A: 14.49,
    B1: 11.68,
    B2: 10.15
  };

  get monthYear() {
    const months = [
      'janvier','février','mars','avril','mai','juin',
      'juillet','août','septembre','octobre','novembre','décembre'
    ];
    const now = new Date();
    return `${months[now.getMonth()]} ${now.getFullYear()}`;
  }

  get isComputed() {
    return this.result > 0;
  }

  @Watch('calcul', { deep: true })
  calculateRent() {
    const { surface, surface_terrace, geozone, isRdc } = this.calcul;

    const sHab = parseFloat(String(surface)) || 0;
    const sTerr = parseFloat(String(surface_terrace)) || 0;

    if (sHab <= 0 || !this.plafond[geozone]) {
      this.result = 0;
      return;
    }

    const base = this.plafond[geozone];
    const sTerrUtil = isRdc ? 0 : sTerr;
    const surfaceUtile = sHab + Math.min(sTerrUtil / 2, 9);
    const coef = Math.min(0.7 + (19 / sHab), 1.2);
    const loyer = base * coef * surfaceUtile;

    // 🔍 LOG DE DEBUG COMPLET
    console.log('--- CALCUL PINEL ---');
    console.log('Zone         :', geozone);
    console.log('Base €/m²    :', base);
    console.log('Surf. Hab.   :', sHab);
    console.log('Terrasse     :', sTerr);
    console.log('Terr. comptée:', sTerrUtil);
    console.log('Surf. Utile  :', surfaceUtile);
    console.log('Coef Pinel   :', coef);
    console.log('Résultat brut:', loyer);

    this.result = parseFloat(loyer.toFixed(2));
  }
}
